module.exports = __webpack_public_path__ + "static/media/expanded-project-responsive-qr-code@2x.5bcae2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expanded-project-responsive-qr-code@2x.png
// module id = 176
// module chunks = 0